module.exports = __webpack_public_path__ + "media/noDetail.8a3b9418.mp3";